import { FindReportSideNavItem, FindReportSideNavItemTag } from '..';

export const emptyReportTag: FindReportSideNavItemTag = {
  category: '',
  categoryId: 0,
  categoryOrder: 0,
  description: '',
  name: '',
  reportId: 0,
  reportType: '',
  reportTypeId: 0,
  subCategory: '',
  subCategoryId: 0,
  isAllowPIT: true,
  runType: '',
  preLocalizedName: '',
  isAllowSplitByAllocationForReport: false,
};

export const buildCustomReportTag = (
  selectedReport: FindReportSideNavItem,
  reportDescription?: string,
): FindReportSideNavItemTag => {
  emptyReportTag.name = selectedReport.name;
  emptyReportTag.preLocalizedName = selectedReport.preLocalizedName;
  emptyReportTag.description = reportDescription ?? '';
  return emptyReportTag;
};
